<template>
  <div class="la-login-box">
<!--    <div class="login-header-box">
      <img src="../../assets/logo.png" class="sys-logo" alt="logo">
      <span class="sys-name">{{ name }}</span>
    </div>-->

    <div class="login-body-box">
      <div class="login-left-box">
        <img class="login-body-img" src="../../assets/login_body_bg.png" alt="" />
      </div>

      <div class="login-right-box">
        <div class="login-title">账号登陆</div>

        <div class="login-form">
          <el-form :rules="rules" :model="loginForm" ref="loginForm" @submit.native.prevent="onLogin">
            <el-form-item prop="account">
              <el-input style="width: 280px;" placeholder="请输入账号" v-model="loginForm.account"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input  style="width: 280px" placeholder="请输入密码" type="password"
                v-model="loginForm.password"></el-input>
            </el-form-item>

            <el-form-item prop="verifyCode">
              <div class="input-group">
                <el-input
                    prefix-icon="el-icon-circle-check"
                    placeholder="请输入图形验证码"
                    class="verify-input"
                    v-model="loginForm.verifyCode"
                >
                </el-input>
                <img @click="handleRefreshVerifyCode" class="verify-img" :src="verifyCodeUrl" style="cursor: pointer"
                     alt="">
              </div>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" native-type="submit" style="width: 280px;margin-top: 30px">登录</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "LaLogin",
  data() {
    return {
      loginForm: {
        account: '',
        password: '',
        verifyCode: "",
      },
      rules: {
        account: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        verifyCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      verifyCodeUrl: ""
    };
  },
  methods: {
    handleRefreshVerifyCode(){
      this.verifyCodeUrl = (this.$api.auth.verifyCode  + "?t=" + new Date().getTime());
    },
    onLogin() {
      const vm = this;
      vm.$refs['loginForm'].validate(valid => {
        if (valid) {
          vm.$http.post(vm.$api.auth.login, vm.$qs.stringify({
            account: vm.loginForm.account,
            password: vm.loginForm.password,
            verifyCode: vm.loginForm.verifyCode
          })).then(res => {
            console.log(res.data)
            if (res.data.status === 200) {
              vm.$message.success(res.data.desc);
              let result = {
                ...res.data.data.passport,
                roleFlag: res.data.data.roleFlag
              }
              window.sessionStorage.setItem('login-user-info',JSON.stringify(result));
              this.$store.dispatch("loadAllDict");
              vm.$router.push({ path: '/' });
            } else {
              this.handleRefreshVerifyCode();
              if(res.data?.desc) {
                vm.$message.error(res.data.desc);
                return;
              }
              let errors = res.data.data?.errorFields || [];
              errors.forEach(item => {
                vm.$message.error(item?.message || "请求失败");
              })
            }
          });
        }
      });
    },
  },
  created() {
    this.handleRefreshVerifyCode();
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variable.scss";

@keyframes flutter {
  0% {
    transform: translate(-50%, -50%);
  }

  50% {
    transform: translate(-50%, -55%);
  }

  100% {
    transform: translate(-50%, -50%);
  }
}

.la-login-box {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: $color-grey;

  .login-bg {
    position: absolute;
    top: 100%;
    left: 0;
    width: 800px;
    transform: translate(0, -55%);
  }

  .login-header-box {
    font-size: 24px;
    font-weight: bold;
    text-align: left;
    position: absolute;
    top: 5%;
    left: 5%;

    .sys-logo {}

    .sys-name {
      display: inline-block;
      margin-left: 18px;
      transform: translateY(-70%);
    }

  }

  .login-body-box {
    width: 700px;
    height: 430px;
    box-shadow: 5px 5px 20px 0 rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #FFFFFF;
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;

    .login-left-box {
      width: 300px;
      height: 100%;
      //float: left;
      position: relative;
      border-radius: 10px 0 0 10px;
      background: linear-gradient(#1eb0e9, #6c39de);

      .login-body-img {
        width: 240px;
        position: absolute;
        top: 60%;
        left: 50%;
        transform: translate(-50%, -50%);
        animation: flutter 2.5s infinite;
        -webkit-animation: flutter 2.5s infinite;

      }
    }

    .login-right-box {
      flex: 1;
      height: 100%;
      padding: 30px 60px;

      .login-title {
        height: 50px;
        line-height: 50px;
        font-size: 20px;
        width: 100%;
        font-weight: bold;
        text-align: left;
        margin-bottom: 60px;
      }

      .login-form {
        text-align: center;
      }

      .input-group {
        display: flex;
        column-gap: 10px;
        .verify-input {
          flex: 1;
        }

        .verify-img {
          height: 40px;
          width: 35%;
        }

      }
    }
  }
}




</style>
